import React from 'react';
import { Loader2 } from 'lucide-react';

const PublishModal = ({
  showPublishModal,
  publishName,
  setPublishName,
  localAssessmentConfig,
  changeSummary,
  setChangeSummary,
  setShowPublishModal,
  handlePublish,
  publishing
}) => {
  if (!showPublishModal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 dark:bg-opacity-70 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl dark:shadow-gray-900/20 max-w-lg w-full p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">Publish Assessment</h2>
        
        <div className="mb-4 p-4 bg-primary-50 border border-primary-200 rounded-lg">
          <p className="text-sm text-primary-800">
            Publishing will create a locked version <strong>(v1.0)</strong> that cannot be edited. 
            To make changes after publishing, you'll need to create a new version.
          </p>
        </div>
        
        {/* Assessment Name */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Assessment Name
          </label>
          <input
            type="text"
            value={publishName}
            onChange={(e) => setPublishName(e.target.value)}
            placeholder={localAssessmentConfig?.name || 'Enter assessment name'}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
          />
          <p className="text-xs text-gray-500 mt-1">Leave blank to keep current name</p>
        </div>
        
        {/* Change Summary */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Change Summary <span className="text-gray-400 text-xs font-normal">(optional)</span>
          </label>
          <textarea
            value={changeSummary}
            onChange={(e) => setChangeSummary(e.target.value)}
            placeholder="Describe the changes in this version..."
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
            rows="3"
          />
        </div>

        <div className="flex space-x-3">
          <button
            onClick={() => {
              setShowPublishModal(false);
              setChangeSummary('');
              setPublishName('');
            }}
            className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700"
          >
            Cancel
          </button>
          <button
            onClick={handlePublish}
            disabled={publishing}
            className="flex-1 px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-lg hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {publishing ? (
              <span className="flex items-center justify-center">
                <Loader2 className="w-4 h-4 animate-spin mr-2" />
                Publishing...
              </span>
            ) : (
              'Publish'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PublishModal;
